<script>
import { mapGetters } from 'vuex'
import rankingCard from '@widgets/ranking-card.vue'

export default {
  components: {
    rankingCard,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('ui', {
      positions: 'getPositions',
    }),
    loaderSkeletons: function() {
      return this.loading ? [1, 2, 3, 4, 5, 6, 7] : []
    },
  },
  methods: {},
}
</script>

<template>
  <div class="mt-4">
    <h3 class="mb-2"> {{ $t('widget_ranking_title') }}</h3>

    <v-row dense>
      <v-col
        v-for="ranking in positions"
        :key="ranking"
        :class="$style.rankingCol"
        md="6"
        sm="12"
      >
        <rankingCard :position="ranking" />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.rankingCol {
  composes: fourcol;
}
</style>
